module.exports = __webpack_public_path__ + "static/silly-816b50441ee5b0f958d685907584e5d5.png";